import { FlowNodeTypes } from '../components/types';
export const getConfirmButtonVerb = (node) => {
    return node.nodeType === FlowNodeTypes.ACTION ? 'Save' : 'Update';
};
